import { createMutationHook } from '~/shared/providers/api';

export const useDeleteFreightLaneCostMutation = createMutationHook(
  'transportation.freightLaneCostDelete',
  (params: { id: string }) => ({
    transportationFreightLaneCostDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
